// src/components/circuit/icons.jsx
// Icone SVG inline condivise per la gestione/creazione circuiti (no dipendenze).
import React from 'react';

export const Svg = ({ children, size = 16, className = '', stroke = 'currentColor', strokeWidth = 2, ...rest }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
        aria-hidden="true"
        focusable="false"
        {...rest}
    >
        {children}
    </svg>
);

export const IconTrack = (props) => (
    <Svg {...props}>
        <path d="M4 12a8 8 0 1 1 16 0v3a3 3 0 0 1-3 3h-2a1 1 0 1 1 0-2h2a1 1 0 0 0 1-1v-3a6 6 0 1 0-12 0v3a1 1 0 0 0 1 1h2a1 1 0 1 1 0 2H7a3 3 0 0 1-3-3v-3z" />
        <circle cx="12" cy="12" r="2" />
    </Svg>
);

export const IconFlag = (props) => (
    <Svg {...props}>
        <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z" />
        <line x1="4" y1="22" x2="4" y2="15" />
    </Svg>
);

export const IconRuler = (props) => (
    <Svg {...props}>
        <path d="M21.21 15.89A10 10 0 1 1 8 2.83" />
        <path d="M22 12A10 10 0 0 0 12 2v10z" />
    </Svg>
);

export const IconWidth = (props) => (
    <Svg {...props}>
        <path d="M3 12h18" />
        <path d="M7 8l-4 4 4 4M17 8l4 4-4 4" />
    </Svg>
);

export const IconSearch = (props) => (
    <Svg {...props}>
        <circle cx="11" cy="11" r="8" />
        <line x1="21" y1="21" x2="16.65" y2="16.65" />
    </Svg>
);

export const IconEdit = (props) => (
    <Svg {...props}>
        <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
        <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
    </Svg>
);

export const IconSave = (props) => (
    <Svg {...props}>
        <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />
        <polyline points="17 21 17 13 7 13 7 21" />
        <polyline points="7 3 7 8 15 8" />
    </Svg>
);

export const IconCheck = (props) => (
    <Svg {...props}><polyline points="20 6 9 17 4 12" /></Svg>
);

export const IconX = (props) => (
    <Svg {...props}>
        <line x1="18" y1="6" x2="6" y2="18" />
        <line x1="6" y1="6" x2="18" y2="18" />
    </Svg>
);

export const IconTrash = (props) => (
    <Svg {...props}>
        <polyline points="3 6 5 6 21 6" />
        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
    </Svg>
);

export const IconInfo = (props) => (
    <Svg {...props}>
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="16" x2="12" y2="12" />
        <line x1="12" y1="8" x2="12.01" y2="8" />
    </Svg>
);

export const IconLayers = (props) => (
    <Svg {...props}>
        <polygon points="12 2 2 7 12 12 22 7 12 2" />
        <polyline points="2 17 12 22 22 17" />
        <polyline points="2 12 12 17 22 12" />
    </Svg>
);

export const IconPlus = (props) => (
    <Svg {...props}>
        <line x1="12" y1="5" x2="12" y2="19" />
        <line x1="5" y1="12" x2="19" y2="12" />
    </Svg>
);

export const IconChevronDown = (props) => (
    <Svg {...props}><polyline points="6 9 12 15 18 9" /></Svg>
);

export const IconBox = (props) => (
    <Svg {...props}>
        <rect x="3" y="3" width="18" height="18" rx="2" />
        <path d="M3 9h18M9 3v18" />
    </Svg>
);

export const IconMapPin = (props) => (
    <Svg {...props}>
        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
        <circle cx="12" cy="10" r="3" />
    </Svg>
);

export const IconUndo = (props) => (
    <Svg {...props}>
        <polyline points="1 4 1 10 7 10" />
        <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10" />
    </Svg>
);

export const IconBack = (props) => (
    <Svg {...props}><polyline points="15 18 9 12 15 6" /></Svg>
);

export const IconCorner = (props) => (
    <Svg {...props}>
        <path d="M4 20V10a6 6 0 0 1 6-6h10" />
        <polyline points="16 2 20 4 16 6" />
    </Svg>
);

export const IconKerb = (props) => (
    <Svg {...props}>
        <rect x="2" y="9" width="20" height="6" rx="1" />
        <line x1="7" y1="9" x2="7" y2="15" />
        <line x1="12" y1="9" x2="12" y2="15" />
        <line x1="17" y1="9" x2="17" y2="15" />
    </Svg>
);
